"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tools.personalData.name': 'Personal Data Detection',
    'tools.personalData.description': 'Extract and categorize personal data from user messages such as phone numbers, emails, addresses, names, etc.',
};
